"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import './AGGridTable.css';
const getColor = (varName) => getComputedStyle(document.documentElement).getPropertyValue(varName).trim() || '';
ModuleRegistry.registerModules([
    AllCommunityModule
]);
export const AGGridTable = ({ className = '', height = '400px', width = '100%', ...agGridProps }) => {
    const [isDarkMode, setIsDarkMode] = useState(false);
    useEffect(() => {
        const checkDarkMode = () => {
            setIsDarkMode(document.documentElement.classList.contains('dark'));
        };
        checkDarkMode();
        const observer = new MutationObserver(checkDarkMode);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class']
        });
        return () => observer.disconnect();
    }, []);
    const customTheme = useMemo(() => {
        const primaryColor = getColor('--color-primary') || '#0ea5e9';
        const primaryForeground = getColor('--color-primary-foreground') || '#ffffff';
        const defaultBorder = getColor('--color-default-300') || '#d4d4d8';
        return themeQuartz.withParams({
            backgroundColor: 'var(--color-background)',
            foregroundColor: 'var(--color-text-primary)',
            accentColor: 'var(--color-primary)',
            borderColor: 'var(--color-border)',
            headerBackgroundColor: 'var(--color-surface)',
            spacing: 8,
            checkboxCheckedBackgroundColor: primaryColor,
            checkboxCheckedBorderColor: primaryColor,
            checkboxCheckedShapeColor: primaryForeground,
            checkboxUncheckedBackgroundColor: 'transparent',
            checkboxUncheckedBorderColor: defaultBorder,
            checkboxIndeterminateBackgroundColor: primaryColor,
            checkboxIndeterminateBorderColor: primaryColor
        });
    }, [isDarkMode]);
    const containerStyle = {
        height,
        width,
    };
    const containerClasses = [
        'ag-theme-quartz',
        'transition-theme',
        className
    ].filter(Boolean).join(' ');
    return (_jsx("div", { className: containerClasses, style: containerStyle, children: _jsx(AgGridReact, { theme: customTheme, ...agGridProps }) }));
};
export default AGGridTable;
//# sourceMappingURL=AGGridTable.js.map